// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"fe44f322","268":"ba9b5131","703":"b2f4d321"}[chunkId] + ".chunk.css";
};